"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-collapsible";
//#region src/components/atoms/Collapsible/Collapsible.tsx
var r = ({ ...e }) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "collapsible",
	...e
}), i = e(({ ...e }, r) => /* @__PURE__ */ t(n.CollapsibleTrigger, {
	"data-slot": "collapsible-trigger",
	...e,
	ref: r
}));
i.displayName = "CollapsibleTrigger";
var a = ({ ...e }) => /* @__PURE__ */ t(n.CollapsibleContent, {
	"data-slot": "collapsible-content",
	...e
});
//#endregion
export { a as CollapsibleContent, r as CollapsibleRoot, i as CollapsibleTrigger };
